import * as React from 'react'
import FormikMoneyField from '../../../Formik/FormikMoneyField'
import FormikFormattableNumberInputField from '../../../Formik/FormikFormattableNumberInputField'
import { ReactElement } from 'react'
import { FieldArray, useFormikContext } from 'formik'
import { FileMutationDto } from '../../../../config/fileConfig'
import { Stack } from '@fluentui/react'
import TierList from '../../Tier/TierList'
import { InsolvencyModuleDto, useFileModule } from '../../../../hooks/module/useFileModule'
import { ModuleType } from '../../../../context/GlobalContext'
import { RateFieldProps } from './RateFields'
import { UserInsolvencyTierDto } from '../../../../config/finance/financeConfig'
import { UserInsolvencyTierListItem } from '../../Tier/UserInsolvencyTierListItem'
import UserInsolvencyTierFormContainer, { userInsolvencyTierValidationSchema } from '../../Tier/UserInsolvencyTierFormContainer'
import { getDefaultTierValue } from './RateFieldsContents'

function getDefaultInsolvencyTierValue(currency: string, insolvencyModule: InsolvencyModuleDto): UserInsolvencyTierDto {
    return {
        ...getDefaultTierValue(currency),
        type: 'USER_INSOLVENCY_TIER',
        role: undefined,
        estateRate: insolvencyModule?.rateEstate || '100.00',
        factorExperience: '1.0',
        factorEstate: insolvencyModule?.factorEstate || '1.0',
        factorTotal: insolvencyModule?.factorEstate || '1.0',
    }
}

export default function RateFieldsInsolvencyContents({ orientation }: RateFieldProps): ReactElement {
    const { values } = useFormikContext<FileMutationDto<UserInsolvencyTierDto>>()
    const { fileModule: insolvencyModule, index: moduleNumber } = useFileModule<InsolvencyModuleDto>(ModuleType.Insolvency, values)

    return (
        <>
            {insolvencyModule && (
                <>
                    <FormikFormattableNumberInputField<any>
                        orientation={orientation}
                        labelKey={'file.edit.form.finance.rates.factorestate'}
                        fieldName={`modules[${moduleNumber}].factorEstate`}
                        decimals={1}
                        align={'end'}
                        selectOnFocus
                    />
                    <FormikMoneyField<any>
                        orientation={orientation}
                        labelKey={'file.edit.form.finance.rates.rateestate'}
                        fieldName={`modules[${moduleNumber}].rateEstate`}
                        currency={values.currency}
                        align={'end'}
                        selectOnFocus
                    />
                </>
            )}
            <Stack>
                <FieldArray name="tiers">
                    {() => (
                        <TierList<FileMutationDto<UserInsolvencyTierDto>, UserInsolvencyTierDto>
                            labelPrefixKey={'file.edit.form.finance.rates.tier'}
                            defaultTierValue={() => getDefaultInsolvencyTierValue(values.currency, insolvencyModule)}
                            parentValues={values}
                            createListItem={(index: number, item: UserInsolvencyTierDto, editTier) => (
                                <UserInsolvencyTierListItem index={index} item={item} editTier={editTier} insolvencyModule={insolvencyModule} />
                            )}
                            createTierFormContainer={props => <UserInsolvencyTierFormContainer {...props} />}
                            validationSchema={userInsolvencyTierValidationSchema}
                        />
                    )}
                </FieldArray>
            </Stack>
        </>
    )
}
